/* eslint-disable eqeqeq */

import React from 'react';
import { getAdvantagesArray } from '../utils/ExpertsUtils';

function ExpertsAdvatages(props) {
    const array = getAdvantagesArray(props.isExperts, props.is5)
    const onClick = (item) => {
        props.setPickedAdvantage(item)
        console.log("ExpertsAdvatages item = ", item)
    }
    return (
        <div style={props.style ? props.style : {}} className="experts_advatages">
            {props.isExperts == undefined && <div className='experts_advatages_title'>Преимущества</div>}
            {array.map((item, index) => (
                <div onClick={() => props.setPickedAdvantage ? onClick(item) : {}} className='flex experts_advatages_item hover' index={index} key={index}>
                    <img alt='' className='advantages_icon' src={item.icon}/>
                    <div className='advantages_icon_title'>{item.title}</div>
                </div>
            ))}
            

        </div>
    )
}

export default ExpertsAdvatages;